import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { UpdateInvestigationFieldValuesCommand } from './update-investigation-field-values.command';

@Injectable({ providedIn: 'root' })
export class UpdateInvestigationFieldValuesUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: UpdateInvestigationFieldValuesCommand): Observable<void> {
    this._state.setSavingFieldValues(true);

    return this._repository.updateFieldValues(command.investigationId, command.fieldValues).pipe(
      tap(() => {
        this._state.setSavingFieldValues(false);
      }),
      catchError((error) => {
        this._state.setSavingFieldValues(false);
        return throwError(() => error);
      }),
    );
  }
}
